export default function updateLoadBalancerReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_LOAD_BALANCER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_LOAD_BALANCER_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_LOAD_BALANCER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}